import { stockMovementValue } from "./stockValuation";
import { collection, doc, increment, runTransaction } from "firebase/firestore";
import { db } from "../firebase";
import { normalizeStockLinks } from "./stockManagement";

export default async function updateProductQuantity(productOrId, decreaseAmount, isOption, context = {}) {
  const rawProductId = typeof productOrId === "string" ? productOrId : productOrId?.id;
  const productId = String(rawProductId || "").split(":")[0];
  const ref = doc(db, isOption ? "OptionProducts" : "products", productId);

  try {
    await runTransaction(db, async (transaction) => {
      const snap = await transaction.get(ref);
      if (!snap.exists()) throw new Error("Product not found");

      const productData = { ...snap.data(), ...(typeof productOrId === "object" ? productOrId : {}) };
      const stockLinks = normalizeStockLinks(productData);

      if (stockLinks.length <= 0) {
        const currentQty = productData.availableQuantity ?? 0;
        const newQty = currentQty - decreaseAmount;
        transaction.update(ref, { availableQuantity: newQty, outOfStock: newQty <= 0 });
        return;
      }

      const stockSnapshots = await Promise.all(stockLinks.map(link => transaction.get(doc(db, 'StockItems', link.stockItemId))));
      stockLinks.forEach((link, index) => {
        const consumedQuantity = Number(decreaseAmount || 0) * Number(link.quantityPerSale || 0);
        if (!link.stockItemId || !Number.isFinite(consumedQuantity) || consumedQuantity <= 0) return;

        const stockRef = doc(db, "StockItems", link.stockItemId);
        const movementRef = doc(collection(db, "StockMovements"));
        transaction.update(stockRef, {
          onHand: increment(-consumedQuantity),
        });
        transaction.set(movementRef, {
          venueId: productData.uid || context.venueId || null,
          stockItemId: link.stockItemId,
          delta: -consumedQuantity,
          ...stockMovementValue(stockSnapshots[index].data(), -consumedQuantity),
          reason: "sale",
          productId,
          orderId: context.orderId || null,
          createdAt: Date.now(),
        });
      });
    });
  } catch (error) {
    console.error("Error updating product quantity:", error);
  }
}
